import { lazy } from 'react'

// Route pages load on demand.
const PartnerModules = {
    List: lazy(() => import('./components/List')),
    Detail: lazy(() =>
        import('./components/Detail').then((m) => ({
            default: m.DetailPartner,
        }))
    ),
    SupplierDetail: lazy(() => import('./components/SupplierDetail')),
}
export default PartnerModules
